import type { Module } from './types';

export const CATEGORY_ACCENTS: Record<string, string> = {
  security: '#3070e7',
  networking: '#16bdeb',
  cloud: '#049fd9',
  data: '#7c5bbf',
  development: '#ff9000',
};

export function categoryAccent(category?: string) {
  return CATEGORY_ACCENTS[category || ''] || '#6b7280';
}

export function youtubeIdFromContent(content: Module['content']): string | null {
  if (!content) return null;
  if (content.videoId) return String(content.videoId);

  const url: string = content.url || content.embedUrl || '';
  const fromWatch = url.split('v=')[1]?.split('&')[0];
  if (fromWatch) return fromWatch;

  const fromPath = url.match(/(?:youtu\.be\/|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{11})/);
  return fromPath ? fromPath[1] : null;
}

export function userRatingValue(userRating: unknown): number {
  if (typeof userRating === 'number') return userRating;
  if (userRating && typeof userRating === 'object' && typeof (userRating as any).rating === 'number') {
    return (userRating as any).rating;
  }
  return 0;
}

/** Moodle modules are stored as `/trainings/{id}` paths. */
export function moodleCourseIdFromUrl(url?: string): string {
  const match = (url || '').match(/^\/trainings\/([^/]+)$/);
  return match ? match[1] : '';
}
